// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.V7kTH{display:inline-flex;flex-wrap:wrap;gap:.25rem}.V7kTH .ui.label{cursor:default;min-width:2.25rem;text-align:center}.V7kTH .ui.label.KQtTw{filter:saturate(.6);opacity:.15}.op2uP.ui.popup{min-width:15rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `V7kTH`,
	"muted": `KQtTw`,
	"popup": `op2uP`
};
module.exports = ___CSS_LOADER_EXPORT___;
